//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PropertyAnswerSyncBackModal',
  props: {
    modalId: {
      type: String,
      required: true
    },
    conflicts: {
      type: Array,
      default: () => []
    },
    projectName: {
      type: String,
      default: ''
    }
  },
  methods: {
    onUpdate() {
      this.$emit('resolve', { action: 'update' })
    },
    onKeep() {
      this.$emit('resolve', { action: 'keep' })
    }
  }
}
